import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import ShiftReportDataTable from './ShiftReport';

const ShiftReportIndex = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);;
  return (
    <>
      <Row className="mt-4 mb-1">
        <Col xs={12}>
          <h4 className="text-uppercase margin-fix mb-0">Reporte de modificaciones y/o alteraciones de turnos</h4>
        </Col>
      </Row>
      <ShiftReportDataTable />
    </>
  );
};

export default ShiftReportIndex;
